import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { Header, Footer } from "components/CoreLayout";
import {MSidebar, ExpiredPasswordModal} from "components/Shared";
import {setCoreLayoutHeaderVisibility} from "actions/layout";

// This is a class-based component because the current
// version of hot reloading won't hot reload a stateless
// component at the top-level.
class CoreLayout extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const {headerVisible, setCoreLayoutHeaderVisibility} = this.props;
    if(!headerVisible)
      setCoreLayoutHeaderVisibility(true);
  }

  render() {
    const { children, history } = this.props;

    let currentRoute = children.props.children.find(function (item) {
      const routeSpec = item.props.path;
      const routeActual = history.location.pathname;

      if (!routeSpec || !routeActual)
        return false;

      const specParts = routeSpec.split("/");
      const actualParts = routeActual.split("/");

      if (specParts.length !== actualParts.length)
        return false;

      for (let i = 0; i < specParts.length; i++) {
        const spec = specParts[i];
        const actual = actualParts[i];

        if (spec[0] === ":")
          continue;

        if (spec !== actual)
          return false;
      }
      return true;
    });

    const { headerVisible, sidebarVisible } = this.props;

    let bodyClassName = `app-body${headerVisible ? "" : " header-hidden"}`;
    if (currentRoute && currentRoute.props.rootCssClass) {
      bodyClassName += ` ${currentRoute.props.rootCssClass}`;
    }

    return (
        <div className={"CoreLayout-Root"}>
          {sidebarVisible && <MSidebar/>}
          <div className="app">
              {(currentRoute && headerVisible) &&
                <div className="app-header">
                  <div className="top-menu-bar md-grid">
                    <div className="header-child">
                      {" "}
                      {(this.props.headerDefinitions &&
                        this.props.headerDefinitions.topMenuTitle) ||
                        currentRoute.props.topMenuTitle}{" "}
                    </div>
                    <Header
                      history={this.props.history}
                      pathname={this.props.location.pathname}
                      pathkey={currentRoute.key}
                    />
                  </div>
                </div>
              }
              <section className={`app-body${headerVisible ? "" : " header-hidden"}`}>
                <div className={bodyClassName}>
                    {this.props.children}
                  </div>
                <ExpiredPasswordModal/>
              </section>
              <Footer />
            </div>
          </div>
    );
  }
}

CoreLayout.propTypes = {
  children: PropTypes.element,
  getSidebar: PropTypes.func.isRequired,
  allCardsExpanded: PropTypes.func.isRequired,
  sidebar: PropTypes.object.isRequired,
  assignmentTool: PropTypes.object.isRequired,
  toggleMenuItem: PropTypes.func.isRequired,
  toggleCaseMenuItem: PropTypes.func.isRequired,
  getSearchResults: PropTypes.func.isRequired,
  searchText: PropTypes.string.isRequired,
  token: PropTypes.string.isRequired,
  location: PropTypes.object,
  history: PropTypes.object,
  cardsExpanded: PropTypes.bool,
  resizeRequired: PropTypes.func.isRequired,
  getInternetUserList: PropTypes.func.isRequired,
  getFieldRepList: PropTypes.func.isRequired,
  getAppraiserList: PropTypes.func.isRequired,
  profile: PropTypes.object,

  sidebarExpand: PropTypes.func.isRequired,
  sidebarContract: PropTypes.func.isRequired,

  files: PropTypes.object.isRequired,
  fetchingFiles: PropTypes.bool.isRequired,
  formStatusChange: PropTypes.func.isRequired,
  headerDefinitions: PropTypes.object.isRequired,
  getNewSearchResults: PropTypes.func.isRequired,
  headerVisible: PropTypes.bool,
  sidebarVisible: PropTypes.bool,
  setCoreLayoutHeaderVisibility: PropTypes.func,
};

const mstp = state => ({
  headerVisible: state.layout.coreLayoutSettings.headerVisible,
  sidebarVisible: state.layout.coreLayoutSettings.sidebarVisible,
});

const mdtp = dispatch => ({
  setCoreLayoutHeaderVisibility(params) {
    dispatch(setCoreLayoutHeaderVisibility(params));
  }
});

export default connect(mstp, mdtp)(withRouter(CoreLayout));
